var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mars-view',{staticClass:"item-wrapper"},[_c('mars-view',{staticClass:"item c-font-normal"},[(_vm.text)?_c('mars-view',{staticClass:"text c-line-clamp1",style:([
        {
            'color': _vm.selected ? _vm.selectedColor : _vm.color,
            'font-weight': _vm.selected ? 'bold' : '',
        },
    ])},[_vm._v("\n    "+_vm._s(_vm.parentValue || _vm.text)+"\n")]):_vm._e(),_c('c-triangle',{staticClass:"c-gap-left-small",attrs:{"direction":_vm.up
            ? 2
            : 1,"color":_vm.selected
            ? _vm.selectedColor
            : _vm.color}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }